// YUSPが落ちても現行システムのJSに影響しない原則で、YUSP関連ロジックをここにまとめる
import { Env } from "../env";

declare global {
  interface Window {
    _gravity: Array<any>;
    GravityRD: any;
    $: any;
    eventRecClick: typeof eventRecClick;
  }
}
// ================================================
// yusp_event.js
// ================================================
/* ユーザID設定 */
function setUserId(userId) {
  window._gravity.push({
    type: "set",
    userId: userId
  });
}

/* VIEW イベント */
function eventView(itemId, platform) {
  if (itemId != "") {
    window._gravity.push({
      type: "event",
      eventType: "VIEW",
      itemId: itemId,
      platform: platform,
      splitGroup: "yusp"
    });
  }
  var waitTimer = setInterval(function () {
    if (typeof window.GravityRD === 'undefined') {
      window.$.ajax({
        url: "/cmn/apiYuspJsUndefined/",
        type: "GET",
        dataType: "text"
      })
    }
    clearInterval(waitTimer);
  }, 10000);
}

/* ADD_TO_CART イベント */
function eventAddToCart(itemId, quantity, platform) {
  if (itemId != "") {
    window._gravity.push({
      type: "event",
      eventType: "ADD_TO_CART",
      itemId: itemId,
      quantity: quantity,
      platform: platform,
      splitGroup: "yusp"
    });
  }
}

/* ADD_TO_CART イベント */
/* カタログ商品コードの配列指定（文字列の場合もありえる） */
function eventAddToCartByCtgItemCds(ctgItemCds, qtys, platform) {
  if (ctgItemCds instanceof Array) {
    for (var i = 0; i < ctgItemCds.length; i++) {
      if (qtys[i] == null) {
        eventAddToCart("product" + ctgItemCds[i], "1", platform);
      } else {
        eventAddToCart("product" + ctgItemCds[i], qtys[i], platform);
      }
    }
  } else {
    eventAddToCart("product" + ctgItemCds, qtys, platform);
  }
}

/* ADD_TO_FAVORITES イベント */
function eventAddToFavorites(itemId, platform) {
  if (itemId != "") {
    window._gravity.push({
      type: "event",
      eventType: "ADD_TO_FAVORITES",
      itemId: itemId,
      platform: platform,
      splitGroup: "yusp"
    });
  }
}

/* ADD_TO_FAVORITES イベント */
/* カタログ商品コードの配列指定（文字列の場合もありえる） */
function eventAddToFavoritesByCtgItemCds(ctgItemCds, platform) {
  if (ctgItemCds instanceof Array) {
    var length = ctgItemCds.length;
    for (var i = 0; i < length; i++) {
      eventAddToFavorites("product" + ctgItemCds[i], platform);
    }
  } else {
    eventAddToFavorites("product" + ctgItemCds, platform);
  }
}

/* BUY イベント */
function eventBuy(itemId, quantity, unitPrice, orderId, platform) {
  if (itemId != "") {
    window._gravity.push({
      type: "event",
      eventType: "BUY",
      itemId: itemId,
      quantity: quantity,
      unitPrice: unitPrice,
      orderId: orderId,
      platform: platform,
      splitGroup: "yusp"
    });
  }
}

/* SEARCH イベント */
function eventSearch(query, platform) {
  if (query != "") {
    window._gravity.push({
      type: "event",
      eventType: "SEARCH",
      query: query,
      platform: platform,
      splitGroup: "yusp"
    });
  }
}

/* REC_CLICK イベント
 * eventRecClickはdisplayRecommendationで構築する画面で呼び出せるため、windowに公開する
 */
function eventRecClick(scenarioId, itemId, platform) {
  if (itemId != "") {
    window._gravity.push({
      type: "event",
      eventType: "REC_CLICK",
      scenarioId: scenarioId,
      itemId: itemId,
      platform: platform,
      splitGroup: "yusp"
    });
  }
}
window.eventRecClick = eventRecClick

// ================================================
// yusp_recommendation.js
// ================================================
/**
 * コンテンツURLにサイカタパラメータを付与する
 */
function addSciParameter(area, path, sciParameter, scenarioId) {
  let sciParameterWithUnderscore = sciParameter;
  if (area === '' || path === '' || sciParameter === '' || scenarioId === '') {
    return path;
  }
  if (path.indexOf('http') === 0) {
    return path;
  }
  if (sciParameter.slice(-1) !== '_') {
    sciParameterWithUnderscore = `${sciParameter}_`;
  }
  return `${path}?sc_i=${area + sciParameterWithUnderscore + scenarioId}`;
}

/**
 * コンテンツURLにサイカタパラメータを付与する
 */
function addSciParameterForPath(area, path, scenarioId) {
  const sciParameter = path.replace(/\//g, '_');
  return addSciParameter(area, path, sciParameter, scenarioId);
}

/**
 * 中カテゴリ/小カテゴリ(PC) YUSPレコメンドのコールバック処理
 * 前提：
 * ・W_MIDLOW_CATEGORY_SPECOFF_DIVのDIVタグが存在すること
 * ・yuspCateNameのID指定が存在すること
 */
function callbackWebMidLowCategorySpecoff(result) {
  const yuspCateName = document.getElementById('yuspCateName')?.textContent;
  displayRecommendation(result, 'W_MIDLOW_CATEGORY_SPECOFF_DIV', 'W_MIDLOW_CATEGORY_SPECOFF', `${yuspCateName}のおすすめ特集・キャンペーン`);
}

/**
 * キーワード検索結果(PC) YUSPレコメンドのコールバック処理
 * 前提：
 * ・W_SEARCHRESULT_DIVのDIVタグが存在すること
 * ・yuspQueryのID指定が存在すること
 */
function callbackSearchResult(result) {
  const yuspQuery = document.getElementById('yuspQuery')?.textContent;
  displayRecommendation(result, 'W_SEARCHRESULT_DIV', 'W_SEARCHRESULT', `キーワード「${yuspQuery}」に関連する特集`);
}

/**
 * YUSPレコメンドを描画する
 */
function displayRecommendation(result, divId, scenarioId, title) {
  if (result.items.length === 0) {
    return;
  }
  const div = document.getElementById(divId);

  const headingDiv = document.createElement('div');
  headingDiv.setAttribute('class', 'a-heading -typeh3 u-mb-24');
  div?.appendChild(headingDiv);

  const h2 = document.createElement('h2');
  h2.setAttribute('class', 'a-heading_text');
  h2.appendChild(document.createTextNode(title));
  headingDiv.appendChild(h2);

  const bnrBodyDiv = document.createElement('div');
  bnrBodyDiv.setAttribute('class', 'o-grid -colFixed -cols3 -vmargin24 -hmargin24 u-mb-48');
  bnrBodyDiv.setAttribute('data-col', '3');
  div?.appendChild(bnrBodyDiv);

  const ul = document.createElement('ul');
  ul.setAttribute('class', 'o-grid_inner');
  bnrBodyDiv.appendChild(ul);

  const length = result.items.length;
  for (let i = 0; i < length; ++i) {
    const item = result.items[i];

    if (typeof item.mediumImageUrl === 'undefined') {
      continue;
    }

    const li = document.createElement('li');
    li.setAttribute('class', 'o-grid_cell');
    ul.appendChild(li);

    const a = document.createElement('a');
    a.setAttribute('class', 'a-link');
    const url = addSciParameterForPath('cp_m_b_ot', item.url, scenarioId);
    a.setAttribute('href', url);
    a.setAttribute(
      'onmousedown',
      `eventRecClick('${scenarioId}','${item.itemid}', 'web');`
    );
    if (item.targetWindows === '2') {
      a.setAttribute('target', '_blank');
    }
    li.appendChild(a);

    const liInnerDiv = document.createElement('div');
    liInnerDiv.setAttribute('class', 'a-img -radius u-mb-16');
    a.appendChild(liInnerDiv);

    const imgSpan = document.createElement('span');
    imgSpan.setAttribute('class', 'a-img_imgWrap');
    liInnerDiv.appendChild(imgSpan);

    const img = document.createElement('img');
    img.setAttribute('data-src', item.mediumImageUrl);
    img.setAttribute('alt', item.title);
    img.setAttribute('data-aspectratio', '298/112');
    img.setAttribute('class', 'a-img_img js-lazy-img');
    imgSpan.appendChild(img);

    if (typeof item.mediumDescription !== 'undefined') {
      const textP = document.createElement('p');
      textP.setAttribute('class', 'a-text');
      textP.appendChild(document.createTextNode(item.mediumDescription));
      a.appendChild(textP);
    }
  }
}

/**
 *中カテゴリ/小カテゴリ(PC) YUSPレコメンドを表示する
 *前提：
 *・yuspCategoryPathが設定済みであること
 */
function recommendationWebMidLowCategorySpecoff() {
  window._gravity.push({
    type: 'recommendation',
    scenarioId: 'W_MIDLOW_CATEGORY_SPECOFF',
    numberLimit: 3,
    currentCategoryPath: document.getElementById('yuspCategoryPath')?.textContent,
    platform: 'web',
    resultNames: ['title', 'mediumImageUrl', 'mediumDescription', 'url', 'targetWindows'],
    callback: callbackWebMidLowCategorySpecoff
  });
}

/**
 *検索結果一覧(PC) YUSPレコメンドを表示する
 *前提：
 *・yuspQueryが設定済みであること
 */
function recommendationSearchResult() {
  window._gravity.push({
    type: 'recommendation',
    scenarioId: 'W_SEARCHRESULT',
    numberLimit: 3,
    query: document.getElementById('yuspQuery')?.textContent,
    platform: 'web',
    resultNames: ['title', 'mediumImageUrl', 'mediumDescription', 'url', 'targetWindows'],
    callback: callbackSearchResult
  });
}

// ================================================
// yusp_create_element.js
// yusp_create_element_dev.js
// ================================================
const initYUSP = (server: string, user: string, protocol: string = '//') => {
  (function (g: any, r: any, a: any, v: any, i: any, t: any) {
    let y = r.createElement(v);
    g[a] = g[a] || [];
    g = r.getElementsByTagName(v)[0];
    y.defer = true;
    y.src = protocol + i + '/js/' + t + '/gr_reco5.min.js';
    g.parentNode.insertBefore(y, g);
    y = r.createElement(v);
    y.defer = true;
    y.src = protocol + i + '/' + t + '/JSServlet?cc=1';
    g.parentNode.insertBefore(y, g);
  })(window, document, '_gravity', 'script', server, user);

  window._gravity = window._gravity || [];
}

const initProduction = () => {
  initYUSP('askul-prod.d-saas.com', 'askul-prod')
}

const initDev = () => {
  initYUSP('askul-staging.d-saas.com', 'askul-staging', 'https://');
}

type YUSPRegisterParameter = {
  enableUserId?: boolean;
  enableView?: boolean;
  enableSearch?: boolean;
  enableAddToFavorites?: {
    catalogItemCode: string,
  },
  enableAddToFavoritesByCtgItemCds?: {
    catalogItemCodes: Array<string>,
  },
  enableAddToCart?: {
    catalogItemCodes: Array<string>,
    quantities: Array<number>
  },
  enableBuy?: {
    itemId: string,
    quantity: string,
    unitPrice: string,
    orderId: string,
  };
}

type showYUSPAreaParameter = {
  enableMOrSCategory?: boolean,
  enableSearchResult?: boolean;
}

const WEB_PLATFORM = 'web';

const isProduction = Env.SETTING.production;
let isYUSPInitialized = false;

function init() {
  if (!isYUSPInitialized) {
    if (isProduction) {
      initProduction();
    } else {
      initDev();
    }
    isYUSPInitialized = true;
  }
}

const register = ({
  enableUserId = false,
  enableView = false,
  enableSearch = false,
  enableAddToFavorites = undefined,
  enableAddToFavoritesByCtgItemCds = undefined,
  enableAddToCart = undefined,
  enableBuy = undefined,
}: YUSPRegisterParameter) => { // NOSONAR
  init();
  if (enableUserId) {
    // YUSP連携 ユーザーID連携
    const userId = document.getElementById('userId') as HTMLInputElement | null;
    if (userId && userId?.value) {
      setUserId(userId.value);
    }
  }
  if (enableView) {
    // YUSP連携 VIEWイベント
    const itemId = document.getElementById('itemId') as HTMLInputElement | null;
    if (itemId && itemId?.value) {
      eventView(itemId.value, WEB_PLATFORM);
    }
  }
  if (enableSearch) {
    // YUSP連携 SEARCHイベント
    const query = document.getElementById('query') as HTMLInputElement | null;
    if (query && query?.value) {
      eventSearch(query.value, WEB_PLATFORM);
    }
  }
  if (enableAddToFavorites) {
    // YUSP連携 ADD_TO_FAVORITEイベント
    eventAddToFavorites(`product${enableAddToFavorites.catalogItemCode}`, WEB_PLATFORM)
  }
  if (enableAddToFavoritesByCtgItemCds) {
    // YUSP連携 ADD_TO_FAVORITES イベント
    // カタログ商品コードの配列指定（文字列の場合もありえる）
    eventAddToFavoritesByCtgItemCds(enableAddToFavoritesByCtgItemCds.catalogItemCodes, WEB_PLATFORM)
  }
  if (enableAddToCart) {
    // YUSP連携 ADD_TO_CARTイベント
    eventAddToCartByCtgItemCds(enableAddToCart.catalogItemCodes, enableAddToCart.quantities, WEB_PLATFORM)
  }
  if (enableBuy) {
    // YUSP連携 BUY イベントイベント
    eventBuy(enableBuy.itemId, enableBuy.quantity, enableBuy.unitPrice, enableBuy.orderId, WEB_PLATFORM)
  }
}

const showYUSPArea = ({
  enableMOrSCategory = false,
  enableSearchResult = false,
}: showYUSPAreaParameter) => {
  init();
  if (enableMOrSCategory) {
    // 中、小カテゴリトップ画面でYUSPエリアを表示
    recommendationWebMidLowCategorySpecoff();
  }
  if (enableSearchResult) {
    // 検索結果画面でYUSPエリアを表示
    recommendationSearchResult();
  }
}

const YUSPUtil = {
  register,
  showYUSPArea,
};
export default YUSPUtil;
